export default "__VITE_ASSET__FdH8WJMp__"